/** @jsx jsx */
import React, { useState } from 'react';
import { jsx, cx, cssMap } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import { Box } from '@atlaskit/primitives/compiled/box';
import { CustomerExperienceIcon } from './CustomerExperienceIcon.tsx';
import type { BrandTileIcon_branding$key } from './__generated__/BrandTileIcon_branding.graphql.ts';

type IconSize = 'small' | 'medium' | 'large';

const styles = cssMap({
	iconHidden: {
		display: 'none',
	},
	iconVisible: {
		display: 'block',
	},
	image: {
		width: '100%',
		height: 'auto',
	},
	iconContainerSmall: {
		width: '16px',
		height: '16px',
	},
	iconContainerMedium: {
		width: '24px',
		height: '24px',
	},
	iconContainerLarge: {
		width: '32px',
		height: '32px',
	},
});

const sizeStyleMap = {
	small: styles.iconContainerSmall,
	medium: styles.iconContainerMedium,
	large: styles.iconContainerLarge,
} as const;

export const BrandTileIcon = ({
	brandingFragment,
	size = 'medium',
}: {
	brandingFragment: BrandTileIcon_branding$key;
	size: IconSize;
}): JSX.Element => {
	const [loaded, setLoaded] = useState(false);

	const branding = useFragment(
		graphql`
			fragment BrandTileIcon_branding on CustomerServiceBranding {
				tile {
					url
				}
			}
		`,
		brandingFragment,
	);

	return (
		<>
			<Box xcss={cx(sizeStyleMap[size], loaded ? styles.iconVisible : styles.iconHidden)}>
				<img
					src={branding?.tile?.url ?? undefined}
					alt=""
					css={styles.image}
					onLoad={() => setLoaded(true)}
				/>
			</Box>

			{!loaded && <CustomerExperienceIcon size={size} />}
		</>
	);
};
